import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { constants } from 'src/app/constants';

const GET_MOBILE_APP_ADVERTISEMENT_BY_PAGE_ID = gql`${constants.GRAPHQL.QUERIES.ADVERTISEMENT.GET_ADS}`;

const TRACK_ADVERTISEMENT = gql`${constants.GRAPHQL.QUERIES.ADVERTISEMENT.TRACKING_ADS}`;

@Injectable({
  providedIn: 'root'
})
export class AdvertisementGraphqlService {

  constructor(private readonly apollo: Apollo) {}

  getAdvertisementByPageId(sessionCookie: string, pageId: string, userId?: string, contextUrl?: string,): Observable<any> {
    return this.apollo.query({
      query: GET_MOBILE_APP_ADVERTISEMENT_BY_PAGE_ID,
      variables: {
        contextUrl: contextUrl,
        sessionCookie: sessionCookie,
        pageId: pageId,
        userId: userId
      }
    });
  }

  trackAdvertisement(sessionCookie: string, pageId: string, action: string, trackingId?: string): Observable<any> {
    return this.apollo.query({
      query: TRACK_ADVERTISEMENT,
      variables: {
        sessionCookie,
        pageId,
        action,
        trackingId
      }
    });
  }
}